import { Component, OnInit, Input, Output, EventEmitter, HostListener } from '@angular/core';


import {RootScopeService} from '../../../core/shared-service/root-scope.service';
import { RootScopeDeclare } from '../../../core/rootscope-declare';

@Component({
  selector: 'app-heatmap-header',
  templateUrl: './heatmap-header.component.html',
  styleUrls: ['./heatmap-header.component.css']
})
export class HeatmapHeaderComponent implements OnInit {

  isDropDownVisible = false;
  @Input() dateInfo: string;
  @Input() floorsList: string;
  @Output() changeFloorEvent: EventEmitter<string> = new EventEmitter();

  showTooltip = false;

  rootScopeData: RootScopeDeclare;

  constructor(private rootScopeService: RootScopeService) {
    this.getRootScopeData();
  }

  getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe(rootScopeData => this.rootScopeData = rootScopeData);
  }

  ngOnInit() {
  }

  showHideDropDown(e: Event) {
    this.isDropDownVisible = !this.isDropDownVisible;
    e.stopPropagation();
  }

  onChangeFloor(ind: string) {
    this.changeFloorEvent.emit(ind);
    this.isDropDownVisible = false;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    this.isDropDownVisible = false;
    this.hideInfo();
  }

  showInfo(e: Event) {
    this.showTooltip = true;
    e.stopPropagation();
  }

  hideInfo() {
    this.showTooltip = false;
  }

}
